import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonIcon", "onClick", "tooltipProps", "disabled", "data-test-id"];
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import * as colors from 'HubStyleTokens/colors';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledButton = styled.button.withConfig({
  displayName: "MessageActionsButton__StyledButton",
  componentId: "sc-1p5w3i3-0"
})(["border:unset;background:unset;width:28px;height:28px;border-radius:4px;color:", ";&:hover{background:", ";}&:active{background:", ";}"], colors.SLINKY, colors.GYPSUM, colors.BATTLESHIP);
const MessageActionsButton = _ref => {
  let {
      buttonIcon,
      onClick,
      tooltipProps,
      disabled,
      'data-test-id': dataTestId = 'message-actions-button'
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UITooltip, Object.assign({}, tooltipProps, {
    children: /*#__PURE__*/_jsx(StyledButton, Object.assign({
      onClick: onClick,
      "data-test-id": dataTestId,
      disabled: disabled
    }, otherProps, {
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: buttonIcon,
        size: 16
      })
    }))
  }));
};
MessageActionsButton.displayName = 'MessageActionsButton';
export default MessageActionsButton;